<mat-form-field>
  <mat-label>{{  label || 'Select Group' }}</mat-label>
  <mat-select #partGroupSelect>
    @for (pgroup of partGroups; track pgroup) {
      <mat-option
        value="{{pgroup.group_name}}">
        {{ pgroup.group_name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
